module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "private-office-selected.9912a0e1.svg";